var getHorizontalTrackPositionLeft = function getHorizontalTrackPositionLeft() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var alignment = arguments.length > 1 ? arguments[1] : undefined;
  var leftOffsets = {
    xs: {
      start: '18px',
      end: 'calc(50% + 18px)',
      default: 'calc(50% + 9px)'
    },
    s: {
      start: '24px',
      end: 'calc(50% + 24px)',
      default: 'calc(50% + 12px)'
    },
    l: {
      start: '32px',
      end: 'calc(50% + 32px)',
      default: 'calc(50% + 16px)'
    },
    default: {
      start: '28px',
      end: 'calc(50% + 28px)',
      default: 'calc(50% + 14px)'
    }
  };
  return alignment ? leftOffsets[size][alignment] : leftOffsets[size].default;
};
var getHorizontalTrackPositionRight = function getHorizontalTrackPositionRight() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var alignment = arguments.length > 1 ? arguments[1] : undefined;
  var rightOffsets = {
    xs: {
      start: 'calc(-100% + 13px)',
      end: 'calc(-50% + 14px)',
      default: 'calc(-50% + 9px)'
    },
    s: {
      start: 'calc(-100% + 16px)',
      end: 'calc(-50% + 20px)',
      default: 'calc(-50% + 12px)'
    },
    l: {
      start: 'calc(-100% + 20px)',
      end: 'calc(-50% + 28px)',
      default: 'calc(-50% + 16px)'
    },
    default: {
      start: 'calc(-100% + 18px)',
      end: 'calc(-50% + 24px)',
      default: 'calc(-50% + 14px)'
    }
  };
  return alignment ? rightOffsets[size][alignment] : rightOffsets[size].default;
};

export { getHorizontalTrackPositionLeft, getHorizontalTrackPositionRight };
//# sourceMappingURL=HorizontalStep.helpers.js.map
